import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import facebook from "../../Assets/vectors/Icons/facebook.svg";
import twitter from "../../Assets/vectors/Icons/twitter.svg";
import instagram from "../../Assets/vectors/Icons/instagram.svg";
import location from "../../Assets/vectors/Icons/location.svg";
import phone from "../../Assets/vectors/Icons/phone.svg";
import mail from "../../Assets/vectors/Icons/mail.svg";
import logo from "../../Assets/logo.png";

export default function Footer() {
  return (
    <div className="grid gridFr footer">
      <div>
        <img src={logo} style={{ width: "192px" }} alt="" />
        <div style={{ fontSize: "14px" }}>
          Developed by
          <a href="https://asyncus.com/" target="_blank" rel="noreferrer">
            {" "}
            Asyncus.
          </a>
        </div>
      </div>
      <div style={{ fontSize: "14px" }}>
        <h3 className="mb05">Links</h3>
        <div style={{ marginBottom: "0.275rem" }}>
          <Link to="/about"> About us</Link>
        </div>
        <div style={{ marginBottom: "0.275rem" }}>
          <Link to="/privacy"> Privacy Policy</Link>
        </div>
        <div>
          <Link to="/terms"> Terms & Conditions</Link>
        </div>
      </div>
      <div className="footer-contact" style={{ fontSize: "14px" }}>
        <h3 className="mb05">Contact</h3>
        <div>
          <img src={location} alt="" />
          <span>Via Tiburtina ‎605 - Roma, Zip 00159, Italy</span>
        </div>
        <div>
          <img src={phone} alt="" />
          <a href="tel:+393895097764">+39 389 5097764</a>
        </div>
        <div>
          <img src={mail} alt="" />
          <a href="mailto:admin@madanischoolandcollege.com">
            admin@madanischoolandcollege.com
          </a>
        </div>
      </div>
      <div style={{ fontSize: "14px" }}>
        <h3 className="mb05">Social Links</h3>
        <div>
          <a
            href="https://www.facebook.com/MADANIROME"
            target="_blank"
            rel="noreferrer"
            className="socialLink"
          >
            <img src={facebook} alt="facebook" />
          </a>
          <a
            href="https://www.facebook.com/MADANIROME"
            target="_blank"
            rel="noreferrer"
            className="socialLink"
          >
            <img src={instagram} alt="instagram" />
          </a>
          <a
            href="https://www.facebook.com/MADANIROME"
            target="_blank"
            rel="noreferrer"
            className="socialLink"
          >
            <img src={twitter} alt="twitter" />
          </a>
        </div>
      </div>
    </div>
  );
}
